export function formatDecimal(amount?: string, number = 6): string {
  if (!amount || amount.includes('.') === false) return amount ?? ''
  const amountSplit = amount.split('.')
  amountSplit[1] = amountSplit[1].slice(0, number)
  return amountSplit.join('.')
}
